import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { languageActions } from "../store/slices/LanguageSlice";

const RTL_LANGUAGES = ["ar"];

const TranslateComponent = () => {
  const googleTranslateRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const initGoogleTranslate = () => {
      if (
        (window as any).google?.translate?.TranslateElement &&
        googleTranslateRef.current
      ) {
        // Clean up any previously injected content
        new (window as any).google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,es,pl,hi,zh-CN,ar",
            layout: (window as any).google.translate.TranslateElement
              .InlineLayout.SIMPLE,
          },
          googleTranslateRef.current
        );
      }
    };

    // Always assign the init function
    (window as any).googleTranslateElementInit = initGoogleTranslate;

    // Check if the script already exists
    const scriptExists = document.querySelector(
      'script[src*="translate.google.com/translate_a/element.js"]'
    );

    if (!scriptExists) {
      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } else {
      initGoogleTranslate();
    }

    // MutationObserver to detect language changes
    const observer = new MutationObserver(() => {
      const htmlEl = document.documentElement;
      const lang = htmlEl.getAttribute("lang");
      dispatch(languageActions.setLanguage(lang));
      if (lang && RTL_LANGUAGES.includes(lang)) {
        htmlEl.setAttribute("dir", "rtl");
        document.body.classList.add("rtl");
      } else {
        htmlEl.setAttribute("dir", "ltr");
        document.body.classList.remove("rtl");
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
    });

    return () => observer.disconnect();
  }, []);

  return <div ref={googleTranslateRef}></div>;
};

export default TranslateComponent;
